import React from 'react'
import moment from 'moment'
import {
  DirectionalHint,
  IColumn,
  Icon,
  IconButton,
} from 'office-ui-fabric-react'
import { TableView } from '../../Components/TableView'
import { ExperimentationGroup } from '../../Api/experimentationGroups'

interface Props {
  experimentationGroups: ExperimentationGroup[]
  onManageClick: (experimentationGroup: ExperimentationGroup) => void
  onDeleteClick: (experimentationGroup: ExperimentationGroup) => void
}

export function ExperimentationGroupsTable({
  experimentationGroups,
  onManageClick,
  onDeleteClick,
}: Props) {
  const columns = useColumns({
    onManageClick,
    onDeleteClick,
  })
  return (
    <TableView
      cacheKey={''}
      columns={columns}
      rowToCacheKey={() => ''}
      rows={experimentationGroups.sort(sortExperimentationGroups)}
      onRowClick={onManageClick}
    />
  )
}

function useColumns({
  onManageClick,
  onDeleteClick,
}: {
  onManageClick: (experimentationGroup: ExperimentationGroup) => void
  onDeleteClick: (experimentationGroup: ExperimentationGroup) => void
}): IColumn[] {
  return [
    {
      key: 'type',
      name: '',
      fieldName: 'type',
      minWidth: 20,
      maxWidth: 20,
      isPadded: false,
      isRowHeader: true,
      isIconOnly: true,
      onRender: () => (
        <Icon
          iconName="Group"
          style={{
            fontSize: 14,
            paddingLeft: 5,
            paddingTop: 3,
          }}
        />
      ),
    },
    {
      key: 'title',
      name: 'Title',
      fieldName: 'title',
      minWidth: 250,
      isPadded: false,
      isRowHeader: true,
      onRender: ({ title }: ExperimentationGroup) => (
        <span title={title}>{title}</span>
      ),
    },
    {
      key: 'lastModifiedDate',
      name: 'Last Modified',
      fieldName: 'lastModifiedDate',
      isPadded: true,
      minWidth: 75,
      maxWidth: 100,
      onRender: ({ lastModifiedDate }: ExperimentationGroup) => (
        <span>{moment(lastModifiedDate).format('DD/MM/YYYY')}</span>
      ),
    },
    {
      key: 'creationDate',
      name: 'Created Date',
      fieldName: 'creationDate',
      isPadded: true,
      minWidth: 75,
      maxWidth: 100,
      onRender: ({ creationDate }: ExperimentationGroup) => (
        <span>{moment(creationDate).format('DD/MM/YYYY')}</span>
      ),
    },
    {
      key: 'menu',
      name: '',
      fieldName: '',
      minWidth: 20,
      maxWidth: 20,
      isIconOnly: true,
      onRender: (experimentationGroup: ExperimentationGroup) => (
        <IconButton
          styles={{
            root: {
              height: 18,
            },
            menuIcon: {
              fontWeight: 'bold',
            },
          }}
          menuProps={{
            coverTarget: true,
            directionalHint: DirectionalHint.topCenter,
            items: [
              {
                key: 'manage',
                text: 'Manage',
                iconProps: { iconName: 'edit' },
                onClick: () => onManageClick(experimentationGroup),
              },
              {
                key: 'delete',
                text: 'Delete',
                iconProps: { iconName: 'delete' },
                onClick: () => onDeleteClick(experimentationGroup),
              },
            ],
          }}
        />
      ),
    },
  ]
}

function sortExperimentationGroups(
  a: ExperimentationGroup,
  b: ExperimentationGroup
) {
  return (
    new Date(b.lastModifiedDate).getTime() -
    new Date(a.lastModifiedDate).getTime()
  )
}
